module.exports = __webpack_public_path__ + "static/media/icon_channel_sbt.0e9d41be.svg";